import { Icon } from '@iconify/react'
import { Draggable } from 'react-beautiful-dnd'

import ColumnBandCells from './ColumnBandCells'
import ReleaseHeaderBar from './ReleaseHeaderBar'
import StoryColumns from './StoryColumns'
import styles from '../../ProjectStoryMapBoard.module.css'

const ReleaseBlock = ({
    release,
    releaseIndex,
    gridTemplateColumns,
    boardTracks,
    draggingStoryReleaseId,
    storyDragOverCellKey = null,
    isStoryDragging = false,
    onSyncHorizontalScroll,
    onAddRelease,
    onAddStory,
    onToggleCollapse,
    onOpenStory,
    onOpenRelease,
    releaseMenu,
    storyMenu,
    editingStoryId,
    editingStoryDraft,
    storyInputRef,
    onStoryDraftChange,
    onCommitStoryTitle,
    highlightedCardId,
    isFilterActive = false,
    filterFocusedCardId = null,
    readOnly = false,
}) => {
    const hasFilterMatch =
        isFilterActive &&
        (release?.matchesFilter === true ||
            (release?.stories ?? []).some(
                (story) => story?.matchesFilter === true
            ))

    // Keep persisted isCollapsed, but auto-open while filter matches exist.
    const collapsed = Boolean(release?.isCollapsed) && !hasFilterMatch

    const releaseBlockMatchClass =
        isFilterActive && release.matchesFilter === true
            ? styles.releaseBlockFilterMatch
            : ''

    return (
    <Draggable
        key={release.id}
        draggableId={`release-${release.id}`}
        index={releaseIndex}
        isDragDisabled={readOnly}
    >
        {(releaseDrag, releaseSnapshot) => (
            <div
                ref={releaseDrag.innerRef}
                {...releaseDrag.draggableProps}
                data-story-map-release-block={String(release.id)}
                className={`${
                    releaseSnapshot.isDragging
                        ? styles.releaseBlockDragging
                        : String(release.id) === String(draggingStoryReleaseId)
                          ? styles.releaseBlockStorySource
                          : styles.releaseBlock
                } ${releaseBlockMatchClass} ${
                    collapsed ? styles.releaseBlockCollapsed : ''
                }`}
            >
                <div className={styles.releaseHeaderOverlay}>
                    <ReleaseHeaderBar
                        release={release}
                        releaseDrag={releaseDrag}
                        onOpenRelease={onOpenRelease}
                        releaseMenu={releaseMenu}
                        isFilterActive={isFilterActive}
                        readOnly={readOnly}
                        collapsed={collapsed}
                        onToggleCollapse={() => onToggleCollapse?.(release.id)}
                    />
                </div>

                <div
                    className={styles.releaseGridViewport}
                    onScroll={(event) => onSyncHorizontalScroll(event.currentTarget)}
                >
                    <div className={styles.releaseGridWide}>
                        {!collapsed ? (
                            <div
                                className={styles.columnBandBackdrop}
                                style={{ gridTemplateColumns }}
                            >
                                <ColumnBandCells
                                    tracks={boardTracks}
                                    keyPrefix={`release-${release.id}`}
                                />
                            </div>
                        ) : null}
                        <div className={styles.releaseHeaderSpacer} aria-hidden="true" />
                        {!collapsed ? (
                            <>
                                <div
                                    className={styles.releaseGrid}
                                    style={{ gridTemplateColumns }}
                                >
                                    <StoryColumns
                                        release={release}
                                        boardTracks={boardTracks}
                                        onAddStory={onAddStory}
                                        onOpenStory={onOpenStory}
                                        storyMenu={storyMenu}
                                        editingStoryId={editingStoryId}
                                        editingStoryDraft={editingStoryDraft}
                                        storyInputRef={storyInputRef}
                                        onStoryDraftChange={onStoryDraftChange}
                                        onCommitStoryTitle={onCommitStoryTitle}
                                        highlightedCardId={highlightedCardId}
                                        isFilterActive={isFilterActive}
                                        filterFocusedCardId={filterFocusedCardId}
                                        storyDragOverCellKey={storyDragOverCellKey}
                                        isStoryDragging={isStoryDragging}
                                        readOnly={readOnly}
                                    />
                                </div>
                                <div
                                    className={styles.addReleaseSpacer}
                                    aria-hidden="true"
                                />
                            </>
                        ) : null}
                    </div>
                </div>
                {!readOnly && !isFilterActive ? (
                    <div className={styles.addReleaseSection}>
                        <button
                            type="button"
                            className={styles.addReleaseBtn}
                            onClick={() => onAddRelease(releaseIndex)}
                        >
                            <span className={styles.addReleaseInner}>
                                <Icon icon="mdi:plus" width={14} />
                                ADD RELEASE
                            </span>
                        </button>
                    </div>
                ) : null}
            </div>
        )}
    </Draggable>
    )
}

export default ReleaseBlock
